module.exports = __webpack_public_path__ + "static/img/Round-23-2011.52df49b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-23-2011.jpg
// module id = Bqj8
// module chunks = 0